






































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
    name: 'Login',
    data() {
        return {
            mode: 'login',
            email: '',
            password: '',
            loginError: '',
            disableButton: false,
            forgotSent: false
        }
    },
    created() {
        this.$store.state.routeLoaded = true;
    },
    methods: {
        login() {
            if(this.disableButton) return;
            this.disableButton = true;
            this.loginError = '';
            axios.post(this.$store.state.apiUrl + '/auth/login', { email: this.email, password: this.password })
                .then(() => {
                    this.disableButton = false;
                    (this.$parent as any).checkSession();
                    this.$router.push('/');
                })
                .catch(e => {
                    this.disableButton = false;
                    if(!e.response) {
                        this.loginError = 'Could not reach the server. Check your connection and try again.';
                    } else if(e.response.status === 429) {
                        this.loginError = 'Too many attempts. Please try again later.';
                    } else {
                        this.loginError = 'Invalid email or password.';
                    }
                });
        },
        sendForgotPassword() {
            if(this.disableButton) return;
            this.disableButton = true;
            axios.post(this.$store.state.apiUrl + '/auth/forgot-password', { email: this.email })
                .finally(() => {
                    this.disableButton = false;
                    this.forgotSent = true;
                });
        },
        loginWithHubSpot() {
            (this.$parent as any).openOAuthPopup();
        },
        loginWithGoogle() {
            (this.$parent as any).openOAuthPopup(this.$store.state.apiUrl + '/oauth/google');
        }
    }
})
